<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"
      :useFieldInfo="true"
      :typeslabel="{
        date: '등록일',
      }"
      :types="['field_name', '부서명_과', 'com_name', 'manager_name', 'writer_name', 'date']"
      :options="[
        { type: 'text', label: '작성자', readonly: true },
        { type: 'date', label: '점검일' },
      ]"
    />

    <!-- 구분 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 구분</h5>

      <div class="w-full grid grid-cols-4">
        <radio-group class="justify-between" v-model="form.구분" flex :items="['상반기', '하반기']" />
      </div>
    </div>

    <table-place-of-business
      class="mt-28px"
      :list="form.pobList"
      @updateList="updateList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
      :useEtc="false"
      title="반기별 보고"
      column1-label="사업명"
      :propsInspectTable="inspectTable"
      inspectHeaderTitle="법적의무사항"
      inspectHeaderYes="양호"
      inspectHeaderNo="미흡"
      inspectHeaderNa="해당없음"
      inspectHeaderNote="비고"
    />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" title="파일첨부" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import TablePlaceOfBusiness from "@/components/TablePlaceOfBusiness";
import * as inspectData from "./inspectData";

export default {
  components: {
    FileUploadModule,
    FieldSelectModule,
    RadioGroup,
    TablePlaceOfBusiness,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        this.form.inspectionTitle = this.inspectionTitle;
        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    board: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value && value.writer) {
          if (!this.form.stdInfo.작성자 || this.form.stdInfo.작성자 === "") {
            const writerName = value.writer && value.writer.name ? value.writer.name : null;
            if (writerName) {
              this.form.stdInfo.작성자 = writerName;
            }
          }
        }
      },
    },
  },
  data() {
    return {
      inspectTable: inspectData.inspectTable,
      form: {
        stdInfo: {},
        photoList: [],
        fileList: [],

        구분:"",
        pobList: [],
      },
    };
  },
  methods: {
    updateList(list) {
      this.form.pobList = list;
    },
  },
};
</script>

<style lang="scss" scoped></style>
